export enum ConnectionString {
  StorageConnectionString = 0,
  DICOMStorageConnectionString = 1,
}
